export default __webpack_public_path__ + "static/media/chart.7c76dcef.png";